document.addEventListener("DOMContentLoaded", function () {
  // Chỉ chạy Mega Menu khi ở Desktop
  const isDesktop = () => window.innerWidth >= 1024;

  function setupMegaMenu(navSelector, menuSelector) {
    const navItem = document.querySelector(navSelector);
    const menu = document.querySelector(menuSelector);
    if (!navItem || !menu) return;

    let timer;

    function openMenu() {
      if (!isDesktop()) return; // không chạy trên mobile
      clearTimeout(timer);
      menu.style.display = "block";
    }

    function closeMenu() {
      if (!isDesktop()) return; // không chạy trên mobile
      timer = setTimeout(() => {
        menu.style.display = "none";
      }, 200);
    }

    // Hover only for desktop
    navItem.addEventListener("mouseenter", openMenu);
    navItem.addEventListener("mouseleave", closeMenu);
    menu.addEventListener("mouseenter", openMenu);
    menu.addEventListener("mouseleave", closeMenu);
  }

  // Fabrics mega menu
  setupMegaMenu(".navmenu-item--fabrics", ".mega-menu--fabrics");

  // Accessories mega menu
  setupMegaMenu(".navmenu-item--accessories", ".mega-menu--accessories");

  // Sidebar switching for Accessories (Desktop only)
  const sidebarItems = document.querySelectorAll(".mega-menu__sidebar-item");
  const panels = document.querySelectorAll(".mega-menu__panel");

  sidebarItems.forEach((btn) => {
    btn.addEventListener("mouseenter", () => {
      if (!isDesktop()) return; // tránh ảnh hưởng mobile

      const handle = btn.dataset.accHandle;

      sidebarItems.forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");

      panels.forEach((panel) => {
        panel.classList.toggle("is-active", panel.dataset.accPanel === handle);
      });
    });
  });

  // Khi resize → cập nhật trạng thái mega menu
  window.addEventListener("resize", () => {
    if (!isDesktop()) {
      document
        .querySelectorAll(".mega-menu")
        .forEach((menu) => (menu.style.display = "none"));
    }
  });
});
